export default {
  "1": {
    type: "buttons",
    text:
      "Sie haben die Wahl. Entscheiden Sie, ob Sie gleich online einen Termin buchen möchten oder für die Vereinbarung kontaktiert werden wollen.",
    options: [
      {
        value: "Termin buchen",
      },
      {
        value: "Termin anfragen",
      },
    ],
  },
  "2": {
    type: "buttons",
    text:
      "<p>Sparen Sie Zeit und Geld.</p>Möchten Sie, dass die ARAG die Abrechnung mit den Zahnärztlichen Tageskliniken im tariflichen Rahmen gleich direkt für Sie übernimmt?",
    options: [
      {
        value: "Ja",
      },
      {
        value: "Nein",
      },
    ],
  },
  "3": {
    type: "buttons",
    text: "Wo möchten Sie den Termin wahrnehmen?",
    options: [
      {
        value: "Augsburg",
      },
      {
        value: "Böblingen",
      },
      {
        value: "Landshut",
      },
      {
        value: "Mainaschaff",
      },
      {
        value: "Mainz",
      },
      {
        value: "München - Schwabing",
      },
      {
        value: "München - Sendling",
      },
      {
        value: "Nürnberg",
      },
      {
        value: "Regensburg",
      },
      {
        value: "Riedenburg",
      },
      {
        value: "Reutlingen",
      },
      {
        value: "Schmidmühlen",
      },
      {
        value: "Ulm",
      },
      {
        value: "Würzburg",
      },
    ],
  },
  "4": {
    type: "location",
    text: "Wo möchten Sie den Termin wahrnehmen?",
  },
};
